// Brand themes key dark values on :root.dark.
export const DARK_CLASS = 'dark'
export const DARK_QUERY = '(prefers-color-scheme: dark)'

interface SchemeQuery {
  matches: boolean
  addEventListener: (type: 'change', listener: () => void) => void
}

// Follows the system preference, now and on change.
export function followColorScheme(root: Element, query: SchemeQuery): void {
  const apply = () => root.classList.toggle(DARK_CLASS, query.matches)
  apply()
  query.addEventListener('change', apply)
}
